import {
  ES_USERNAME_LENGTH_CONSTRAINT,
  isEnergyStarUsernameValid,
} from 'common/src/validators/energyStarCredentialValidation';

import {
  passwordInputType,
  textInputType,
} from 'portal/src/components/common/forms/FormFieldTypes';

export type CreateEnergyStarAccountFormValues = ReturnType<
  typeof defaultValues
>;

export const defaultValues = () => ({
  username: '',
  password: '',
  confirmPassword: '',
});

export const getCreateEnergyStarAccountFields = (): (
  | passwordInputType
  | textInputType
)[] => [
  {
    label: 'Username',
    name: 'username',
    placeholder: 'Choose a username',
    required: true,
    type: 'textInput',
    validate: (value: string) =>
      isEnergyStarUsernameValid(value) ||
      `Username must be ${ES_USERNAME_LENGTH_CONSTRAINT}.`,
  },
  {
    label: 'Password',
    name: 'password',
    placeholder: 'Create a password',
    required: true,
    type: 'password',
  },
  {
    label: 'Confirm password',
    name: 'confirmPassword',
    placeholder: 'Re-enter your password',
    required: true,
    type: 'password',
    validate: (value: string, values: CreateEnergyStarAccountFormValues) =>
      value === values.password || 'Passwords do not match.',
  },
];
